import React, { useState, useEffect } from 'react';
import {
  FormBox,
  Title,
  Label,
  ButtonGroup,
  RegButton
} from './StyledComponents';
import BusinessImgUpload from '../BusinessImgUpload';

export default function BusinessImage({ userInfo = {}, bizRegCert, setBizRegCert }) {
  const [photoList, setPhotoList] = useState(bizRegCert ? [{ url: bizRegCert }] : []);

  // 이미지 업로드 함수
  const uploadImage = async () => {
    try {
      const formData = new FormData();
      photoList.forEach((photo, index) => {
        const { url } = photo;
        const imageBlob = base64ToBlob(url);
        const fileName = `bizreg-${index}-image.png`; // 파일명 지정
        formData.append('files', imageBlob, fileName);
      });
      formData.append('domain', 'crm_cinechain');

      // 사업자등록증 업로드를 NAS 파일서버(StorageAgent, 4433)로 이전 — 기존 AWS file.cinechain.co.kr 폐기
      const response = await fetch('https://file.movieexchange.co.kr:4433/upload/files', {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.status} - ${response.statusText}`);
      }

      const result = await response.json();
      console.log('uploadImage 함수 결과:', result);

      // 업로드한 이미지 경로를 bizRegCert로 설정
      
      return result;
    } catch (err) {
      console.error("이미지 업로드 중 오류 발생:", err);
      throw err;
    }
  };

  // Base64 문자열을 Blob으로 변환하는 함수
  function base64ToBlob(base64Str) {
    const base64ContentArray = base64Str.split(",");
    const mimeType = base64ContentArray[0]
      .match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
    const byteCharacters = atob(base64ContentArray[1]);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: mimeType });
  }

  // bizRegCert 변경 감지
  useEffect(() => {
    if (bizRegCert) {
      //console.log('bizRegCert가 업데이트되었습니다:', bizRegCert);
      setPhotoList([{ url: bizRegCert }]);
    }
  }, [bizRegCert]);
  // "이미지 적용하기" 버튼 클릭 시 bizRegCert 업데이트
  const applyImage = async () => {

      try {
        if(bizRegCert===''){
             // 업로드된 경로가 bizRegCert로 설정된 후 서버에 업데이트 요청
             const response = await fetch('/request/updateBizRegCert', {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ bizRegCert: '' }) // 이미지 경로를 서버로 전달
            });
            if (!response.ok) {
              throw new Error(`서버 오류 발생: ${response.statusText}`);
            }
        }
        else{
          const result = await uploadImage();
          // 업로드된 경로가 bizRegCert로 설정된 후 서버에 업데이트 요청
          const response = await fetch('/request/updateBizRegCert', {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ bizRegCert: result.src }) // 이미지 경로를 서버로 전달
          });
          if (!response.ok) {
            throw new Error(`서버 오류 발생: ${response.statusText}`);
          }
        }
          
        alert("이미지가 적용되었습니다: ");
     

        const data = await response.text();
        console.log("사업자 등록증 경로 업데이트 완료:", data);
      } catch (err) {
        console.error("이미지 적용 중 오류 발생:", err);
      }
   
  };

  return (
    <FormBox>
      <>
        <Title>사업자 등록증</Title>
        <Label htmlFor="companyName">이미지 첨부</Label>
        <BusinessImgUpload
          bizRegCert={bizRegCert}
          setBizRegCert={setBizRegCert}
          setImageUrl={setPhotoList}
          setAlign={'center'}
          setWidth={'100%'}
          setHeight={100}
        />
        <ButtonGroup>
          <RegButton style={{ width: '100%' }} type="button" onClick={applyImage}>
            이미지 적용하기
          </RegButton>
        </ButtonGroup>
      </>
  </FormBox>
  );
}